import { Button, Text } from '@customerio/pluma-components/react';
import { isEmptyString } from '@/utils/string';

type CollectionDescriptionTextProps = {
  description: string | null;
};

export function CollectionDescriptionText({ description }: CollectionDescriptionTextProps) {
  const hasDescription = !isEmptyString(description);

  return <Text color={hasDescription ? 'base' : 'subtle'}>{hasDescription ? description : 'No description'}</Text>;
}

type EditFieldButtonProps = {
  ariaLabel: string;
  isDisabled: boolean;
  onClick: () => void;
};

export function EditFieldButton({ ariaLabel, isDisabled, onClick }: EditFieldButtonProps) {
  return (
    <Button
      variant="subtle"
      icon="edit"
      isIconOnly
      aria-label={ariaLabel}
      size="sm"
      isDisabled={isDisabled}
      onClick={onClick}
    />
  );
}
